module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Showcase")]), _vm._v(" "), _c('div', {
    staticClass: "pure-g"
  }, [_vm._l((this.$store.state.showcaseImages), function(showcaseImage) {
    return [_c('div', {
      staticClass: "pure-u-1-8",
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('span', [_vm._v("X")])]), _vm._v(" "), _c('div', {
      staticClass: "pure-u-7-8 truncate-overflow",
      staticStyle: {
        "box-sizing": "border-box"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(showcaseImage)
      }
    })])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "pure-g"
  }, [_c('div', {
    staticClass: "pure-u-5-6 grid__padding--right"
  }, [_c('configurator-input', {
    ref: "inputField",
    attrs: {
      "placeholder": 'Add Image Url'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pure-u-1-6 grid__padding--left"
  }, [_c('vue-r-button', {
    attrs: {
      "label": 'Add',
      "onClick": _vm.addShowcaseImage
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51618004"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/configuratorShowcase.vue
// module id = 67
// module chunks = 0